import * as React from 'react';
const Location = /*#__PURE__*/React.createContext('Not specified');
const AnalyticsLocationProvider = props => /*#__PURE__*/React.createElement(Location.Provider, {
  value: props.location
}, props.children);
const AnalyticsLocationConsumer = props => {
  return /*#__PURE__*/React.createElement(Location.Consumer, null, currentLocation => props.children(currentLocation));
};
export { AnalyticsLocationProvider, AnalyticsLocationConsumer };